import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Loader } from './loader';

type Props = {
  size?: FontAwesomeIconProps['size'];
  className?: string;
};

export const OverlayLoader: React.FC<React.PropsWithChildren<Props>> = ({ size = 'lg', className }) => {
  return (
    <div className={className ? `loader ${className}` : 'loader'}>
      <Loader size={size} />
    </div>
  );
};
